import $ from 'jquery';
import autosize from 'autosize';


function VendorCommonCtrl() {
	this.$textarea = $('textarea');
}

VendorCommonCtrl.prototype.init = function() {
	autosize(this.$textarea, {
		append: "\n"
	})
}

export default VendorCommonCtrl;